import React, {useEffect, useRef, useState} from 'react';
import { BrowserRouter, Routes, Route } from "react-router";

import { createClient, UsermavenProvider } from '@usermaven/react';

import { usePageTransition } from './components/helpers/usePageTransition';
import './App.css';

import { register } from 'register-service-worker'

import { TransitionOverlay } from './components/helpers/TransitionPages';
import ScreenSaver from './components/screensaver/ScreenSaver';
import PathwayMenu from './components/pathwayMenu/PathwayMenu';
import ContentHandler from './components/content/ContentHandler';
import SmPC from './components/helpers/GUI/SmPC';

// Initialize Usermaven client
const usermavenClient = createClient({
  // Required Configuration
  key: 'UMei1sSeus',
  trackingHost: 'https://events.usermaven.com',
  
  // Optional Configuration
  autocapture: true,             // Enable automatic event capturing
  autoPageview: true,            // Automatically track page views
  randomizeUrl: false,           // Randomize URLs to avoid PII collection
  
  // Cross-domain Tracking (Optional)
  crossDomainLinking: false,     // Enable cross-domain tracking
  domains: 'example.com,example.org',  // Specify allowed domains
  
  // Advanced Configuration (Optional)
  namespace: 'cll-eha' 
});


function App() {

  register('./service-worker.js', {
    ready () {
      console.log('Service worker is active.');
    },
    registered () {
      console.log('Service worker has been registered.');
    },
    cached () {
      console.log('Content has been cached for offline use.');
    },
    updatefound () {
      console.log('New content is downloading.');
    },
    updated () {
      console.log('New content is available; please refresh.');
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.');
    },
    error (error) {
      console.error('Error during service worker registration:', error);
    }
  });
  
  const preloadImages = (images: string[]) => {
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  };

  useEffect(() => {
    preloadImages([
      "./assets/profiles/abigail.jpg",
      "./assets/profiles/jeremy.jpg",
      "./assets/profiles/mark.jpg",
      "./assets/powerbyv.webm",
      "./assets/screensavers/screensaver1.mp4",
      "./assets/screensavers/screensaver2.mp4",
      "./assets/screensavers/screensaver3.mp4",
    ]);
  }, [])

  const viewportRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const updateScale = () => {
      const scaleX = window.innerWidth / 1920;
      const scaleY = window.innerHeight / 1080;
      const scale = Math.min(scaleX, scaleY);
      document.documentElement.style.setProperty('--scale', scale.toString());
    };
  
    updateScale();
    window.addEventListener('resize', updateScale);
    return () => window.removeEventListener('resize', updateScale);
  }, []);
  

  const { destination, triggerTransition, clearDestination } = usePageTransition();

  const [isOpenLegal, setOpenLegal] = useState<boolean>(false);
  const [videoPaused, setVideoPaused] = useState<any | null>();

  useEffect(() => {
    const videos = document.querySelectorAll('video');
  
    videos.forEach((video) => {
      if (isOpenLegal && video.paused === false) {
        console.log('video paused', video)
        setVideoPaused(video);
        video.pause();
      }

      if(!isOpenLegal && videoPaused) {
        console.log('video resumed', videoPaused)
        videoPaused.play();
        setVideoPaused(null);
      }

    });
  },[isOpenLegal]);

  return (
    <UsermavenProvider client={usermavenClient}>
      <div id='index_app' className="App">

        <SmPC isOpen={isOpenLegal} setOpen={setOpenLegal} />

        { isOpenLegal && 
          <div className='bg-black bg-opacity-75 w-full h-full z-30 fixed'></div>
        }

        <div className="viewport-wrapper">
          <div className="viewport-content" ref={viewportRef}>
            <BrowserRouter >
              <TransitionOverlay destination={destination} onTransitionEnd={clearDestination} />
              <Routes>
                <Route path="/" element={<ScreenSaver triggerTransition={triggerTransition} />} />
                <Route path="/menu" element={<PathwayMenu  triggerTransition={triggerTransition}  />} />
                <Route path="/profile/:name" element={<ContentHandler triggerTransition={triggerTransition}/>} />
              </Routes>
            </BrowserRouter>
            </div>
          </div>
      </div>
    </UsermavenProvider>
  );
}

export default App;
